import { BrowserRouter, Routes, Route } from "react-router";
import { ChakraProvider } from "@chakra-ui/react";

import HomeScreen from "./homeScreen/HomeScreen";
import LoginScreen from "./loginScreen/LoginScreen";
import Dashboard from "./dashboard/Dashboard";

/**
 * La aplicación principal.
 * 
 * Incluye un ruteo para mostrar la página de login, el semáforo general o el
 * dashboard de un equipo FirmPro específico.
 * 
 * @returns {JSX.Element} 
 */
function App(): JSX.Element {
  return (
    <ChakraProvider>
      {/* 
      Se usa HashRouter porque, al llevar el build al servidor de desarrollo,
      no podía gestionar las rutas de otra manera tal que, al reiniciar una
      página, se quedara en esa misma página en vez de tirar un error. Usar
      BrowserRouter solo funcionaba bien en desarrollo local con npm start.
      
      https://reactrouter.com/6.29.0/router-components/hash-router
      */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/:id" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
